import {
  createPersistedState
} from "./chunk-54L43XJA.mjs";

// src/index.ts
var src_default = createPersistedState();
export {
  createPersistedState,
  src_default as default
};
